<template>
    <div id="ranking" ref="ranking">
        <div>
            <form id="search-form" method="post" ref="search-form" v-on:submit="load">
                <input name="page" ref="page" type="hidden" value="0">
                 <ul v-show="false">
                    <li><input maxlength="30" name="search_txt" placeholder="Buscar por título" ref="search_txt" type="text"></li>
                    <li>
                        <select name="order">
                            <option>Ordenação</option>
                            <option value="0" selected>Mais novas</option>
                            <option value="1">Mais Antigas</option>
                            <option value="2">Ordem alfabética</option>
                        </select>
                    </li>
                     <li>
                        <input id="btn-submit-search" ref="btn-submit-search" type="submit" value="Filtrar">
                     </li>
                </ul>
             </form>
        </div>
       <picture>
            <source :srcset="$url + 'img/bg_acesso.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_acesso.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_acesso.webp'">
        </picture>
        <img id="raio" :src="$url + 'img/ranking/raio_ranking.png'">
        <picture>
            <source :srcset="$url + 'img/ranking/estrelas_ranking.webp'" type="image/webp">
            <source :srcset="$url + 'img/ranking/estrelas_ranking.png'" type="image/png"> 
            <img id="star" :src="$url + 'img/ranking/estrelas_ranking.webp'">
        </picture>
        <img id="icon" :src="$url + 'img/ranking/icon_rankingstar.png'">
        <transition name="fade">
            <div v-if="show" id="box">
                <h3>Ranking</h3>
                <span><a href="#" v-on:click="exit"><img :src="$url + 'img/fechar.png'"></a></span>
                <div id="first" ref="first" v-if="data_.length && ($refs['page'].value == 0)">
                    <ul id="mainList">
                        <li v-if="data_[1]">
                            <h5>{{ data_[1].name ==  name ? data_[1].name : '--' }}</h5>
                            <div class="first first_position">
                                <img :src="$url + 'img/ranking/icon_posicao.png'" style="position:absolute;margin-left: 10px">
                                <div>2</div>
                            </div>  
                            <img :src="$url + 'img/ranking/bgmedalha_ranking.png'" style="margin-top: 40px">
                            <img :src="$url + 'img/x2/perfil_0' + data_[1].avatar + '.png'" width="100" style="margin-top: -180px">
                            <img :src="$url + 'img/moeda.png'" width="30" style="margin-bottom:-10px">
                            {{ data_[1].points }}
                        </li>
                        <li class="second" v-if="data_[0]">
                            <h5>{{ data_[0].name ==  name ? data_[0].name : '--' }}</h5>
                            <div class="first_position">
                                <img :src="$url + 'img/ranking/icon_posicao.png'" style="position:absolute;margin-left: 10px">
                                <div>1</div>
                            </div>  
                            <img :src="$url + 'img/ranking/bgmedalha_ranking.png'" style="margin-top: 40px">
                            <img :src="$url + 'img/x2/perfil_0' + data_[0].avatar + '.png'" width="100" style="margin-top: -180px">
                            <img :src="$url + 'img/moeda.png'" width="30" style="margin-bottom:-10px">
                            {{ data_[0].points }}
                        </li>
                        <li class="third" v-if="data_[2]">
                            <h5>{{ data_[2].name ==  name ? data_[2].name : '--' }}</h5>
                            <div class="first_position">
                                <img :src="$url + 'img/ranking/icon_posicao.png'" style="position:absolute;margin-left: 10px">
                                <div>3</div>
                            </div>  
                            <img :src="$url + 'img/ranking/bgmedalha_ranking.png'" style="margin-top: 40px">
                            <img :src="$url + 'img/x2/perfil_0' + data_[2].avatar + '.png'" width="100" style="margin-top: -180px">
                            <img :src="$url + 'img/moeda.png'" width="30" style="margin-bottom:-10px">
                            {{ data_[2].points }}
                        </li>
                    </ul>
                </div>
                <div id="list" ref="list" v-if="data_.length">
                    <ul>
                        <li v-for="(o, key) in data_" v-bind:key="key">
                            <ul>
                                <li>{{ (key + 1) + ($refs["page"].value * list_n)  }}</li>
                                <li><img :src="$url + 'img/x1/perfil_0' + o .avatar + '.png'" height="40"></li>
                                <li>{{ ((o.name == name) ? o.name : '--') }}</li>
                                <li><img :src="$url + 'img/moeda.png'" height="40"></li>
                                <li>{{ o.points }}</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <pagination-component :pag="pag" v-if="total > list_n" v-show="blocked" :total="total"></pagination-component>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
    import Vue from 'vue';
    import PaginationComponent from "./PaginationComponent";
    import axios from "axios";
   
    export default {
        name: "RankingComponent",
        data() {
            return {
                blocked: false,
                data_  : [],
                errors : null,
                list_n : 10,
                pag    : new Vue(),
                show   : false,
                total  : 0
            }
        },
        computed: {
            ...mapGetters(['token', 'logged', 'id', 'name', 'email', 'points', 'started', 'player', 'avatar', 'mobile'])
        },
        components: {
            PaginationComponent
        },
        methods: {




            exit() {
                this.$router.push('/jogo');
            },



            //----- block -----//
            block(v) {
                this.blocked = (!v ? true : false);
                this.submit = (v ? true : false);
                this.$refs['ranking'].style.cursor = (v ? 'progress' : 'default');
            },
            //----- \block\ -----//
            
            

            //----- load -----//
            load(e) {
                this.block(true);
                if (e) {
                    this.$refs["page"].value = 0;
                    e.preventDefault();
                }
                let form_data = new FormData(this.$refs["search-form"]);
                axios.get(this.$b + 'api/points?' + new URLSearchParams(form_data).toString()).then(response => this.loadResponse(response, (e ? true : false)));
            },
            loadResponse(obj, search) {
                console.log('obj -> ', obj);
                if (obj.data.success === false) {
                    this.errors = obj.data.errors;
                } else if (obj.data.success === true) {
                    this.total = obj.data.total;
                    this.data_ = obj.data.users;
                    if (search)
                        this.pag.$emit('restart', { total: this.total });
                }
                this.block(false);
            },
            //----- -----//



            //----- pagination -----//
            pageHandler(p) {
                this.$refs["page"].value = p;
                this.load();
            },
            //----- -----//



        },
        mounted() {
            this.show = true;
            this.load();
        }
    }
</script>

<style scoped>
   
    
    #bg
    {
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
    }
    #ranking {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 8;
    }
    #raio
    {
        height: 257px;
        left: calc(50% - 249px);
        position: fixed;
        top: 0;
        width: 492px;
    }
    #star
    {
        height: 835px;
        left: calc(50% - 370px);
        position: fixed;
        top: 0;
        width: 740px;
    }
    #icon
    {
        height: 175px;
        left: calc(50% - 80px);
        position: absolute;
        top: -10px;
        width: 198px;
    }
    #box
    {
        background-color: #fff;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: auto;
        left: calc(50% - 250px);
        margin-bottom: 20px;
        /*min-height: 780px;*/
        padding: 10px 0 50px 0;
        position: absolute;
        text-align: center;
        top: 100px;
        width: 500px;
    }


    /*----- first -----*/
    #first
    {
        margin-top: 0px;
    }
    #first > ul > li
    {
        color: #fff;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 40px;
        text-align: center;
        vertical-align: bottom;
        width: 33%;
    }
    #first > ul > li:nth-child(2)
    {
        box-sizing: border-box;
        padding: 50px 0;
    }
    #first > ul > li > img
    {
        display: block;
        margin: 0 auto;
    }
    #first > ul > li > h5
    {
        color: #444;
        display: block;
        font-family: 'Roboto';
        font-size: 12px;
    }
    .first_position
    {
        display: block;
        position: absolute;
        text-align: center;
        width: 52px;
    }
    .first_position > img
    {
        left: 0;
        position: absolute;
        top: -10px;
    }
    .first_position > div
    {
        margin: -6px 0 0 18px;
        position: relative;
    }
    /*----- \first\ -----*/



    /*----- list -----*/
    #list
    {
        font-size: 20px;
        margin-top: 45px;
    }
    #list > ul > li
    {
        display: block;
        height: 50px;
        line-height: 50px;
        list-style: none;
    }
    #list > ul > li > ul > li
    {
        display:inline-block;
        list-style: none;
        text-align: center;
        vertical-align: top;
    }
    #list > ul > li:nth-child(even)
    {
        background-color: #ebf5d5;
    }
    #list > ul > li:nth-child(odd)
    {
        background-color: #f5f9ea;
    }
    #list > ul > li > ul > li:nth-child(1), #list > ul > li > ul > li:nth-child(4)
    {
        color: #9dca26;
        font-family: 'Paper Cutout';
        font-size: 40px;
    }
    #list > ul > li > ul > li:nth-child(1)
    {
        width: 10%;
    }
    #list > ul > li > ul > li:nth-child(2)
    {
        box-sizing: border-box;
        padding-top: 5px;
        width: 15%;
    }
    #list > ul > li > ul > li:nth-child(3)
    {
        text-align: left;
        width: 40%;
    }
    #list > ul > li > ul > li:nth-child(4)
    {
        box-sizing: border-box;
        padding-top: 5px;
        text-align: right;
        width: 10%;
    }
    #list > ul > li > ul > li:nth-child(5)
    {
        color: #9dca26;
        font-family: 'Paper Cutout';
        font-size: 40px;
        text-align: left;
        width: 25%;
    }
    /*----- \list\ -----*/



    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: -30px auto;
        padding: 15px;
        width: 180px;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }

    .btn-01
    {
        background-color: #fff;
        border-radius: 37px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, .2);
        box-sizing: border-box;
        color: #9dca26 !important;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 60px;
        height: 58px;
        line-height: 34px;
        padding: 12px 15px;
        text-align: center;
        width: 90%;
    }
    .btn-01 > a
    {
        position: absolute;
    }
    .rot
    {
        transform: rotate(180deg);
    }
    .fade-enter-active, .fade-leave-active {
        top: calc(50% - 110px);
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 50%;
        opacity: 0;
    }

    @media screen and (max-width: 600px)
    {
        #first > ul > li
        {
            display: block;
            margin: 20px auto;
        }
        #first > ul > li:nth-child(2)
        {
            box-sizing: border-box;
            padding: 0;
        }
        #list > ul > li > ul > li:nth-child(5)
        {
            text-align: center;
        }

        #mainList {
            display: flex;
            flex-direction: column;
        }
        .second {
            order: -1;
        }




        .first_position
        {
            display: block;
            margin-left: -25px;
            position: absolute;
            text-align: center;
            width: 52px;
        }
        .first_position > img
        {
            left: 0;
            position: absolute;
            top: -10px;
        }
        .first_position > div
        {
            margin: -6px 0 0 18px;
            position: relative;
        }




    }
    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 10%;
            width: 80%;
        }
    }
</style>
